import { computed, watch, ref } from 'vue'
import { getTableColumnsWidth, getCollapseColumns } from '@/utils/store-table-size'
export default function useColumns (columns, tableId) {
  const columnsWidth = ref({})
  const collapseColumns = ref(JSON.parse(getCollapseColumns(tableId.value) || '[]'))
  let storedWidth = JSON.parse(getTableColumnsWidth(tableId.value) || '{}')
  const getWidths = (cols) => {
    // storedWidth = JSON.parse(getTableColumnsWidth(tableId.value) || '{}')
    cols.forEach(col => {
      if ('children' in col) {
        getWidths(col.children)
      } else {
        columnsWidth.value[col.dataIndex] = storedWidth[col.dataIndex] || col.width
      }
    })
  }

  const getGridTemplateColumns = (cols) => {
    return cols.map(col => {
      if ('children' in col) {
        return getGridTemplateColumns(col.children)
      } else {
        return columnsWidth.value[col.dataIndex] ? (collapseColumns.value.includes(col.dataIndex) ? '35px' : `${columnsWidth.value[col.dataIndex]}px`) : 'max-content'
      }
    }).join(' ')
  }

  const leftColumns = computed(() => columns.value.filter(item => item.fixed === 'left'))
  const mainColumns = computed(() => columns.value.filter(item => !item.fixed))
  const leftGridTemplateColumns = computed(() => getGridTemplateColumns(leftColumns.value))
  const mainGridTemplateColumns = computed(() => getGridTemplateColumns(mainColumns.value))

  watch([columns, tableId], vals => {
    storedWidth = JSON.parse(getTableColumnsWidth(tableId.value) || '{}')
    collapseColumns.value = JSON.parse(getCollapseColumns(tableId.value) || '[]')
    getWidths(vals[0])
  }, { immediate: true, deep: true })

  return {
    columnsWidth,
    leftColumns,
    mainColumns,
    leftGridTemplateColumns,
    mainGridTemplateColumns,
    collapseColumns
  }
}
